import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { searchUrl, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import axios from "axios";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Table from "react-bootstrap/Table";
import TableHeader from "components/Table/TableHeader";
import PechaKuchaChannelsLocationsTableRow from "components/ManagePechaKucha/PechaKuchaChannelsLocationsTableRow";
import UserContext from "store/UserContext";
import AddEditLocationModal from "components/Modals/AddEditLocationModal";

import { asyncContainer, Typeahead } from "react-bootstrap-typeahead";
const AsyncTypeahead = asyncContainer(Typeahead);

function PechaKuchaLocations(props) {
  const context = UserContext;
  let temp_pagination_from = 0;
  const pagination_limit = 100;

  const [location_table_loading, setLocationTableLoading] = useState(true);
  const [locations, setLocations] = useState();
  const [pagination_from, setPaginationFrom] = useState(0);
  const [total_search_results, setTotalSearchResults] = useState(0);
  const [message, setMessage] = useState();
  const [error_message, setErrorMessage] = useState();
  const [isFiltering, setIsFiltering] = useState(false);
  const [modalShowing, setModalShowing] = useState(false);
  const [editableLocation, setEditableLocation] = useState();

  const locations_table_header_display = {
    Name: "",
    "City Page": "",
    Created: "",
    "": "",
  };
  let workspace_base_url = "";

  useEffect(() => {
    (async () => {
      await getLocationsFromApi();
    })();
  }, []);

  async function getLocationsFromApi() {
    let query_filter = "all";
    try {
      let locations_search_response = await axios.get(
        `${searchUrl}sitesearch?sort_by=entity_name&sort_order=desc&entity_type=locations&q=${encodeURIComponent(
          query_filter
        )}&all_statuses=true&from=${temp_pagination_from}&limit=${pagination_limit}`,
        myHeaders_Auth_With_Cache_Control
      );
      console.log("locations_search_response:", locations_search_response);
      let search_query_results =
        locations_search_response.data &&
        locations_search_response.data.search_query_results
          ? locations_search_response.data.search_query_results
          : [];
      setLocations(search_query_results.map((data) => data.entity_info));

      if (
        locations_search_response.data &&
        locations_search_response.data.additional_information &&
        "total_search_results" in
          locations_search_response.data.additional_information
      ) {
        setTotalSearchResults(
          locations_search_response.data.additional_information
            .total_search_results
        );
      }
    } catch (err) {
      console.error("Search Error!", err);
    }
    setLocationTableLoading(false);
  }

  async function paginationHandler(e) {
    let new_pagination_from = 0;
    if (e.direction === "forward") {
      new_pagination_from = pagination_from + pagination_limit;
      setPaginationFrom(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go past the end
      if (new_pagination_from >= locations) {
        new_pagination_from = pagination_from;
      }
    } else if (e.direction === "backward") {
      new_pagination_from = pagination_from - pagination_limit;
      setPaginationFrom(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go below 0
      if (new_pagination_from < 0) {
        new_pagination_from = 0;
      }
    }
    setLocationTableLoading(true);
    await getLocationsFromApi();
  }

  async function clearSearch() {
    setLocationTableLoading(true);
    ref.current.clear();
    await getLocationsFromApi();
  }

  async function resetFilter(event) {
    if (event.key === "Enter") {
      if (event.target.value === "") {
        setLocationTableLoading(true);
        setPaginationFrom(0);
        temp_pagination_from = 0;
        await getLocationsFromApi();
      }
    }
  }

  //TypeAhead stuff
  const ref = useRef();
  const filterBy = () => true;

  async function filteringLocations(query_filter) {
    setIsFiltering(true);
    setLocationTableLoading(true);
    let locations_search_response = await axios.get(
      `${searchUrl}sitesearch?sort_by=entity_name&sort_order=desc&entity_type=locations&q=${encodeURIComponent(
        query_filter
      )}&from=${temp_pagination_from}&limit=${pagination_limit}`,
      myHeaders_Auth_With_Cache_Control
    );

    let search_query_results =
      locations_search_response.data &&
      locations_search_response.data.search_query_results
        ? locations_search_response.data.search_query_results
        : [];
    setLocations(search_query_results.map((data) => data.entity_info));
    setTotalSearchResults(null);
    setLocationTableLoading(false);
    setIsFiltering(false);
  }

  async function selectedFilteredLocation(selectedLocation) {
    setPaginationFrom(0);
    temp_pagination_from = 0;
    setLocations(selectedLocation);
    setLocationTableLoading(false);
  }

  const handleShow = (locationInfo) => {
    setModalShowing(true);
    setEditableLocation(locationInfo);
  };

  async function handleClose() {
    setModalShowing(false);
    setEditableLocation();
    await getLocationsFromApi();
  }

  return (
    <div className="presenters-info pkListContainer eventCreation">
      <Row>
        <Col lg={12}>
          <br />
          <h1>PechaKucha Cities</h1>
          <hr />
          <br />
          <Button variant="pkprimary" onClick={handleShow} className="mb-2">
            Add City
          </Button>
          <Row>
            <Col>
              <div className="search-nav border">
                <i className="fa fa-search nav-search"></i>
                <AsyncTypeahead
                  id="LocationTypeAhead"
                  // labelKey={(channel) =>
                  //   `${location.entity_name} - ${location.friendly_url}`
                  // }
                  labelKey="friendly_url"
                  isLoading={isFiltering}
                  filterBy={filterBy}
                  placeholder="Search/Filter Cities"
                  ref={ref}
                  minLength={0}
                  onChange={selectedFilteredLocation}
                  onSearch={filteringLocations}
                  options={locations}
                  onKeyDown={resetFilter}
                />
              </div>
            </Col>
            <Col>
              <button
                style={{ marginTop: "0px" }}
                className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons"
                onClick={clearSearch}
              >
                Clear Search and Refresh
              </button>
            </Col>
          </Row>

          {location_table_loading && (
            <div className="createEventSpinner">
              <ActivityIndicator theme="spinner" />
            </div>
          )}
          {!location_table_loading && (
            <React.Fragment>
              {message && (
                <span style={{ color: "green", paddingTop: "10px" }}>
                  <br />
                  {message}
                </span>
              )}
              {error_message && (
                <span style={{ color: "red", paddingTop: "10px" }}>
                  <br />
                  {error_message}
                </span>
              )}
              <p className="related-name" style={{ float: "right" }}>
                {pagination_from > 0 && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      paginationHandler({ direction: "backward" });
                    }}
                  >
                    Previous
                  </span>
                )}
                {pagination_from + pagination_limit < total_search_results &&
                  pagination_from + pagination_limit < 1000 && (
                    <span
                      style={{ marginLeft: "20px", cursor: "pointer" }}
                      onClick={() => {
                        paginationHandler({ direction: "forward" });
                      }}
                    >
                      Next
                    </span>
                  )}
              </p>
              <div className="table-boby">
                <Table variant={context.theme} responsive={true}>
                  <tbody>
                    {/* Pending section header*/}
                    <TableHeader
                      headerType="Cities"
                      tableHeader={locations_table_header_display}
                      listLength={locations.length}
                    />
                    {/* Pending section Body*/}

                    {locations.map((item, i) => {
                      return (
                        <PechaKuchaChannelsLocationsTableRow
                          key={i}
                          data={item}
                          workspace_base_url={workspace_base_url}
                          handleShow={handleShow}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </React.Fragment>
          )}
        </Col>
      </Row>
      {editableLocation ? (
        <AddEditLocationModal
          show={modalShowing}
          locationInfo={editableLocation}
          handleClose={() => handleClose()}
        />
      ) : null}
    </div>
  );
}

export default PechaKuchaLocations;
